/**
 * Messages d’erreur Supabase/PostgREST (souvent en anglais) → texte actionnable en français.
 */
export function humanizeAuthError(message) {
  if (message == null || typeof message !== "string" || !message.trim()) {
    return "Une erreur s’est produite. Réessayez dans quelques instants.";
  }
  const raw = message.trim();
  const m = raw.toLowerCase();

  if (
    m.includes("rate limit") ||
    m.includes("email rate") ||
    m.includes("for security purposes") ||
    m.includes("only request this after")
  ) {
    return "Trop d’e-mails d’inscription ou de vérification ont été demandés. Attendez 1 à 2 minutes, puis réessayez une seule fois. Si vous avez déjà un compte, connectez-vous (ou mot de passe oublié) plutôt que de recréer un compte.";
  }

  if (m.includes("user already registered") || m.includes("already been registered") || m.includes("already registered")) {
    return "Un compte existe déjà avec cette adresse. Connectez-vous ou réinitialisez le mot de passe.";
  }

  if (m.includes("invalid login credentials") || m.includes("invalid email or password")) {
    return "E-mail ou mot de passe incorrect.";
  }

  if (m.includes("email not confirmed") || m.includes("email address not confirmed")) {
    return "E-mail non confirmé. Ouvrez le lien reçu par e-mail, ou redemandez l’e-mail de confirmation depuis l’écran de connexion si l’option est proposée.";
  }

  if (m.includes("column") && m.includes("does not exist")) {
    return "L’inscription ne peut pas être enregistrée (configuration de la base). Contactez le support RdvMarket.";
  }

  return raw;
}
